module.exports = __webpack_public_path__ + "static/media/night_flight_sample_1.7cf022bb.jpg";